<div class="braintree-checkout-wrapper">

  <!-- Loading state -->
  <div *ngIf="isLoading" class="bt-loading text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <!-- Error message -->
  <div *ngIf="errorMessage && !isLoading" class="alert alert-danger mt-2">
    {{ errorMessage }}
  </div>

  <!-- Payment options (use [hidden] so DOM exists for hosted fields mounting) -->
  <div [hidden]="isLoading" class="bt-payment-container">


    <!-- New Card Form (Hosted Fields) -->
    <div class="bt-hosted-fields">
      
      <div class="form-group">
        <label for="bt-card-number">Card Number</label>
        <div id="bt-card-number" class="bt-hosted-field form-control"></div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-6">
          <label for="bt-expiration-date">Expiration Date</label>
          <div id="bt-expiration-date" class="bt-hosted-field form-control"></div>
        </div>
        <div class="form-group col-md-6">
          <label for="bt-cvv">CVV</label>
          <div id="bt-cvv" class="bt-hosted-field form-control"></div>
        </div>
      </div>

      <div *ngIf="vaultOnSuccess" class="form-check mb-3">
        <small class="text-muted">
          <i class="fas fa-lock mr-1"></i>
          Your card will be securely saved for future purchases
        </small>
      </div>
    </div>

    <!-- Submit button -->
    <button
      type="button"
      class="btn btn-primary btn-block mt-3"
      [disabled]="isSubmitting || !canSubmit()"
      (click)="submitPayment()">
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm mr-1"></span>
      <span *ngIf="!isSubmitting">
        <i class="fas fa-lock mr-1"></i> Pay Securely
      </span>
      <span *ngIf="isSubmitting">Processing...</span>
    </button>

  </div>
</div>

